<div fxLayout="row" fxLayoutAlign="start center" class="h-100">
    <mat-form-field class="h-100 page-size-container">
        <mat-select hideSingleSelectionIndicator
                    class="h-100 t3"
                    fxLayoutAlign="start center"
                    panelClass="hide-scroll-bar"
                    [value]="currentPageEvent.pageSize"
                    (valueChange)="emitPageSizeChanged($event)" fxFlex>
            @for (pageSize of pageSizes; track pageSize) {
                <mat-option [value]="pageSize">{{ pageSize }}</mat-option>
            }
        </mat-select>
        <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-900" name="ic_arrow_down"></ui-kit-svg>
    </mat-form-field>
    <div class="page-number-container" fxLayout="row" fxLayoutAlign="center center">
        <div class="page-label t3"
             [innerHtml]="'i18n_af_labelPaginatorPages' | translate : {
        class: 'c-primary-gray-900',
        pageNumber: currentPageEvent.pageNumber+1,
        totalPages: totalPages
        } | safeHtml">
        </div>
        <div class="page-switcher-container" fxLayout="row" fxLayoutAlign="space-between center">
            <ui-kit-svg class="i-16 icon"
                        [class.disabled]="currentPageEvent.pageNumber === INITIAL_PAGE_NUMBER"
                        name="ic_arrow_left"
                        (click)="currentPageEvent.pageNumber !== INITIAL_PAGE_NUMBER && emitPageChanges(-1)">
            </ui-kit-svg>
            <ui-kit-svg class="i-16 icon"
                        [class.disabled]="currentPageEvent.pageNumber === (totalPages-1)"
                        name="ic_arrow_right"
                        (click)="(currentPageEvent.pageNumber !== totalPages-1) && emitPageChanges(1)">
            </ui-kit-svg>
        </div>
    </div>
</div>
